// Constant values for timings in milliseconds, add more as and when required.

const MILLISECONDS_PER_SECOND: number = 1000;
const SECONDS_PER_MINUTE: number = 60;
const MINUTES_PER_HOUR: number = 60;
const HOURS_PER_DAY: number = 24;

export const ONE_SECOND = MILLISECONDS_PER_SECOND;
export const ONE_MINUTE = ONE_SECOND * SECONDS_PER_MINUTE;
export const FIVE_MINUTES = ONE_MINUTE * 5;
export const THIRTY_MINUTES = ONE_MINUTE * 30;
export const ONE_HOUR = ONE_MINUTE * MINUTES_PER_HOUR;
export const ONE_DAY = ONE_HOUR * HOURS_PER_DAY;